import React from 'react'
import { useParams } from 'react-router-dom'

// hooks
import useGroup from '../../hooks/useGroup'

// components
import Error404 from '../../components/error404/Error404'
import GroupInfo from './components/groupInfo'
import LoadingSpinner from '../../components/loadingSpinner'
import Breadcrumbs from '../../components/Breadcrumbs'

import styles from './viewGroup.module.scss'

function ViewGroup() {
  const { groupId } = useParams()
  const { group, isGroupLoading } = useGroup(groupId)
  if (isGroupLoading) return <LoadingSpinner />
  if (Object.keys(group).length === 0) {
    return <Error404 />
  }

  const breadcrumbPath = [
    { label: 'groups-edit-tab', path: '/search-group' },
    { label: `${group?.displayName}`, path: `/view-group/${groupId}` }
  ]
  return (
    <>
      <div className={styles.viewGroupContainer}>
        <Breadcrumbs crumbs={breadcrumbPath} className={styles.pageHeaderBreadcrumbs} />
      </div>
      <GroupInfo group={group} />
    </>
  )
}

export default ViewGroup
